<div class="schedule-settings-container">
    <div class="settings-header">
        <h2>SCHEDULE SETTINGS</h2>
        <p class="hint" *ngIf="stateMode">Personalise your schedule by defining custom appointment types and colour-coding
            them for easy identification.</p>
        <p class="hint" *ngIf="!stateMode">Personalise your schedule by defining custom appointment types and colour-coding them for easy
            identification. Whenever a patient appointment is booked, rescheduled, or cancelled, MedicAI will promptly
            email patients to confirm the change. Additionally, MedicAI sends a reminder at 6 AM on the day of each
            appointment, for the appointment types (and bookings) set to send one. Please ensure patients have provided accurate email addresses
            to receive these notifications effectively.
        </p>
    </div>


    <mat-accordion multi="false">

        <!-- <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    AVAILABILITY SETTINGS
                    <mat-icon class="expansion-header-icon" (click)="openEditAvailabilityDialog($event)"
                        matTooltip="Edit your schedule availability" color="primary">edit</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <p><strong>Available Days:</strong> {{getAvailableDaysList(days)}}</p>

        </mat-expansion-panel> -->

        <!-- <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    BLOCKED DATES
                    <mat-icon class="expansion-header-icon" (click)="openBlockedDatesDialog($event)"
                        matTooltip="Add a new blocked date range" color="primary">add</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-form-field class="full-width" appearance="outline">
                <mat-label>Blocked Dates</mat-label>
                <mat-chip-grid #blockedDatesChipGrid>
                    <mat-chip-row *ngFor="let blockedDate of blockedDates"
                        appTouchEdit (dblclick)="openBlockedDatesDialog(null, blockedDate)">
                        {{blockedDate.startDate | date: 'dd/MM/yyyy'}}{{blockedDate.endDate && blockedDate.endDate !==
                        blockedDate.startDate
                        ? ' - ' + (blockedDate.endDate | date: 'dd/MM/yyyy') : ''}}
                        <button matChipRemove (click)="deleteBlockedDate(blockedDate.id)">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip-row>
                </mat-chip-grid>
                <input [matChipInputFor]="blockedDatesChipGrid" disabled />
                <mat-hint>Double click or tap and hold a blocked date range to edit its information</mat-hint>
            </mat-form-field>
        </mat-expansion-panel> -->

        <mat-expansion-panel [expanded]="false" tutorialExpansionTarget="TIME_SLOT">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    TIME SLOT SETTINGS
                    <mat-icon class="expansion-header-icon" (click)="openEditTimeslotDialog($event)"
                        matTooltip="Edit your appointment time slot duration" color="primary"
                        tutorialHighlightTarget="TIME_SLOT">edit</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <p><strong>Start Time:</strong> {{ timeSettings.startTime }}</p>
            <p><strong>End Time:</strong> {{ timeSettings.endTime }}</p>
            <p><strong>Time Slot Duration:</strong> {{ timeSettings.timeSlotDuration }} minutes</p>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    BOOKING CAPACITY
                    <mat-icon class="expansion-header-icon" (click)="openEditCapacityDialog($event)"
                        matTooltip="Edit how many patients can share a time slot" color="primary">edit</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <p><strong>Patients Limit:</strong> {{ capacitySettings.patientsLimit === 'capped' ? 'Capped' : 'Unlimited' }}</p>
            <p *ngIf="capacitySettings.patientsLimit === 'capped'"><strong>Patients per Time Slot:</strong>
                {{ capacitySettings.patientsPerTimeSlot }}</p>
            <p class="hint">
                {{ capacityHint() }}
            </p>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    LOCATIONS
                    <mat-icon class="expansion-header-icon" (click)="openLocationDialog($event)"
                        matTooltip="Add a new location" color="primary">add</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-form-field class="full-width" appearance="outline">
                <mat-label>Locations</mat-label>
                <mat-chip-grid #locationChipGrid>
                    <mat-chip-row *ngFor="let location of locations"
                        appTouchEdit (dblclick)="openLocationDialog(null, location)">
                        {{location.name}}{{location.isDefault ? ' (Default)' : ''}}
                        <button matChipRemove (click)="deleteLocation(location)">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip-row>
                </mat-chip-grid>
                <input [matChipInputFor]="locationChipGrid" disabled />
                <mat-hint>One location per place the practice works from. Double click or tap and hold a location to edit it</mat-hint>
            </mat-form-field>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="false" tutorialExpansionTarget="APPOINTMENT_TYPE">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    APPOINTMENT TYPES
                    <mat-icon class="expansion-header-icon" (click)="openAppointmentTypeDialog($event)"
                        matTooltip="Add a new appointment type" color="primary"
                        tutorialHighlightTarget="APPOINTMENT_TYPE">add</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <mat-form-field class="full-width" appearance="outline">
                <mat-label>Appointment Types</mat-label>
                <mat-chip-grid #chipGrid>
                    <mat-chip-row *ngFor="let appointmentType of appointmentTypes"
                        appTouchEdit (dblclick)="openAppointmentTypeDialog(null, appointmentType)">
                        {{appointmentType.type}} {{appointmentType.isProcedure ? '(For Theatre)': ''}}
                        {{appointmentType.durationMinutes ? '· ' + appointmentType.durationMinutes + ' min' : ''}}
                        {{typeLocationsLabel(appointmentType) ? '· ' + typeLocationsLabel(appointmentType) : ''}}
                        <button matChipRemove (click)="deleteAppointmentType(appointmentType.id)">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip-row>
                </mat-chip-grid>
                <input [matChipInputFor]="chipGrid" disabled />
                <mat-hint>Double click or tap and hold an appointment type to edit its information</mat-hint>
            </mat-form-field>
        </mat-expansion-panel>

        <!-- <mat-expansion-panel *ngIf="group">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    APPOINTMENT REMINDER MESSAGE
                    <mat-icon class="expansion-header-icon" (click)="openAppointmentReminderDialog()"
                        matTooltip="Edit your appointment reminder message" color="primary">{{group.appointmentReminder
                        ? 'edit' : 'add'}}</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <pre *ngIf="group.appointmentReminder" [innerHtml]="group.appointmentReminder"
                class="preserve-line-breaks consent-text"></pre>
        </mat-expansion-panel> -->
    </mat-accordion>
    <div class="mobile-spacer"></div>
    <!-- 
    <div class="appointment-types-section">
        <div class="action-heading">
            <h3>Appointment Types</h3>
            <button mat-icon-button (click)="addAppointmentType()"
                matTooltip="Add a new appointment type"><mat-icon>add</mat-icon></button>
        </div>
        <div class="appointment-settings-container">
            <div *ngFor="let appointmentType of appointmentTypes; let i = index" class="type-section">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Type</mat-label>
                    <input matInput [(ngModel)]="appointmentTypes[i].type" [disabled]="!appointmentTypes[i].canDelete">
                </mat-form-field>

                <div class="toggle-container">
                    <mat-slide-toggle [(ngModel)]="appointmentTypes[i].isProcedure" color="primary"
                        [disabled]="!appointmentTypes[i].canDelete">For
                        Theatre</mat-slide-toggle>
                </div>

                <div class="color-fields p-b-20">
                    <ngx-colors matTooltip="Set background color for this appointment type" ngx-colors-trigger
                        [(ngModel)]="appointmentTypes[i].backgroundColor" [hideTextInput]="true"
                        class="m-r-5"></ngx-colors>

                    <ngx-colors matTooltip="Set text color for this appointment type" ngx-colors-trigger
                        [(ngModel)]="appointmentTypes[i].textColor" [hideTextInput]="true"></ngx-colors>
                </div>

                <button *ngIf="appointmentType.canDelete" matTooltip="Delete appointment type" mat-icon-button
                    color="warn" (click)="removeAppointmentType(i)" class="m-b-20">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>

        </div>

    </div> -->
</div>

<ng-template #availabilitySettingsDialog>
    <h1 mat-dialog-title>Availability Settings</h1>

    <div mat-dialog-content>
        <div class="form-container">
            <div class="days-section">
                <h3>Available Days</h3>
                <mat-checkbox *ngFor="let day of days" [(ngModel)]="day.selected">{{ day.name }}</mat-checkbox>
            </div>
        </div>
    </div>

    <mat-dialog-actions align="end">
        <div mat-dialog-actions class="dialog-actions">
            <button mat-raised-button color="primary" [mat-dialog-close]="days">Save</button>
        </div>
    </mat-dialog-actions>

</ng-template>

<!-- 
<ng-template #blockedDateDialog>
    <h1 mat-dialog-title>Blocked Date Settings</h1>

    <div mat-dialog-content>
        <div class="form-container">

            <mat-form-field appearance="outline" class="full-width m-t-10">
                <mat-label>Blocked Date Range</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate [(ngModel)]="editingBlockedDate.startDate" placeholder="Start Date">
                    <input matEndDate [(ngModel)]="editingBlockedDate.endDate" placeholder="End Date">
                </mat-date-range-input>
                <mat-hint>DD/MM/YYYY - DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width m-t-10">
                <mat-label>Reason</mat-label>
                <textarea matInput [(ngModel)]="editingBlockedDate.reason" rows="4"></textarea>
            </mat-form-field>

            <div class="upcoming-holidays m-t-20 hint">
                <p>Upcoming South African Public Holidays:</p>
                <p>{{getUpcomingHolidays()}}</p>
            </div>

        </div>
    </div>

    <mat-dialog-actions align="end">
        <div mat-dialog-actions class="dialog-actions">
            <button mat-raised-button color="primary" [mat-dialog-close]="editingBlockedDate">Save</button>
        </div>
    </mat-dialog-actions>

</ng-template> -->


<ng-template #timeslotSettingsDialog>
    <h1 mat-dialog-title>Time Slot Settings</h1>

    <div mat-dialog-content>
        <div class="m-t-10">

            <mat-form-field appearance="outline">
                <mat-label>Start Time</mat-label>
                <input matInput [(ngModel)]="timeSettings.startTime" [ngxTimepicker]="startTimePicker" [format]="24">
                <ngx-material-timepicker #startTimePicker [theme]="darkTheme" [appendToInput]="true"
                    (timeSet)="validateEndSlot(timeSettings)" [preventOverlayClick]="true"></ngx-material-timepicker>
            </mat-form-field>


            <mat-form-field appearance="outline">
                <mat-label>End Time</mat-label>
                <input matInput [(ngModel)]="timeSettings.endTime" [ngxTimepicker]="endTimePicker" [format]="24">
                <ngx-material-timepicker #endTimePicker [theme]="darkTheme" [appendToInput]="true"
                    [preventOverlayClick]="true" (timeSet)="validateEndSlot(timeSettings)"></ngx-material-timepicker>
                <mat-error *ngIf="endTimeInvalid">
                    End time must be after start time
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Duration</mat-label>
                <!-- String values on purpose: Schedule.timeSlotDuration is stored as a string ('30'). -->
                <mat-select [(ngModel)]="timeSettings.timeSlotDuration">
                    <mat-option *ngFor="let minutes of durationOptions" [value]="'' + minutes">{{ minutes }}
                        minutes</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <mat-dialog-actions align="end">
        <div mat-dialog-actions class="dialog-actions">
            <button mat-raised-button color="primary" [mat-dialog-close]="timeSettings">Save</button>
        </div>
    </mat-dialog-actions>

</ng-template>


<ng-template #capacitySettingsDialog let-capacity>
    <h1 mat-dialog-title>Booking Capacity</h1>

    <div mat-dialog-content>
        <div class="m-t-10">
            <h4>Patients Limit</h4>
            <mat-radio-group [(ngModel)]="capacity.patientsLimit" class="capacity-radio-group">
                <mat-radio-button value="capped">Capped</mat-radio-button>
                <mat-radio-button value="unlimited">Unlimited</mat-radio-button>
            </mat-radio-group>

            <mat-form-field *ngIf="capacity.patientsLimit === 'capped'" appearance="outline" class="m-t-15">
                <mat-label>Patients per Time Slot</mat-label>
                <input matInput type="number" min="1" max="100" step="1"
                    [(ngModel)]="capacity.patientsPerTimeSlot">
            </mat-form-field>

            <p class="hint">
                Capped: booking a slot that already holds this many appointments or blocked events shows a
                scheduling conflict warning. Unlimited: no warning is shown.
            </p>
        </div>
    </div>

    <mat-dialog-actions align="end">
        <div mat-dialog-actions class="dialog-actions">
            <button mat-button mat-dialog-close>Cancel</button>
            <button mat-raised-button color="primary" [mat-dialog-close]="capacity">Save</button>
        </div>
    </mat-dialog-actions>

</ng-template>


<ng-template #locationDialog>
    <h1 mat-dialog-title>Location</h1>

    <div mat-dialog-content>
        <div class="form-container">
            <mat-form-field appearance="outline" class="full-width m-t-10">
                <mat-label>Name</mat-label>
                <input matInput [(ngModel)]="editingLocation.name" placeholder="e.g. Pretoria">
            </mat-form-field>

            <div class="toggle-container">
                <mat-slide-toggle [(ngModel)]="editingLocation.isDefault" color="primary"
                    [disabled]="editingLocation.isDefault && !!editingLocation.id">Default location</mat-slide-toggle>
            </div>
        </div>
    </div>

    <mat-dialog-actions align="end">
        <div mat-dialog-actions class="dialog-actions">
            <button mat-button mat-dialog-close>Cancel</button>
            <button mat-raised-button color="primary" [disabled]="!editingLocation.name?.trim()"
                [mat-dialog-close]="editingLocation">Save</button>
        </div>
    </mat-dialog-actions>
</ng-template>

<ng-template #appointmentTypeDialog>
    <h1 mat-dialog-title>Appointment Type Settings</h1>

    <div mat-dialog-content>
        <div class="form-container">
            <mat-form-field appearance="outline" class="full-width m-t-10"
                tutorialHighlightTarget="FIELD_APPOINTMENT_NAME">
                <mat-label>Type</mat-label>
                <input matInput [(ngModel)]="editingAppointmentType.type"
                    [disabled]="!editingAppointmentType.canDelete">
            </mat-form-field>

            <div class="toggle-container" tutorialHighlightTarget="FIELD_APPOINTMENT_FOR_THEATRE">
                <mat-slide-toggle [(ngModel)]="editingAppointmentType.isProcedure" color="primary"
                    [disabled]="!editingAppointmentType.canDelete">For
                    Theatre</mat-slide-toggle>
            </div>

            <div class="toggle-container" tutorialHighlightTarget="FIELD_APPOINTMENT_COMMUNICATION_TOGGLE" *ngIf="!stateMode">
                <mat-slide-toggle [(ngModel)]="editingAppointmentType.suppressSending" color="primary">
                    Disable Communication
                </mat-slide-toggle>
            </div>

            <!-- Disable Communication stops reminders too, so this only shows while messages go out. Each booking can change it. -->
            <div class="toggle-container" *ngIf="!editingAppointmentType.suppressSending && !stateMode">
                <mat-slide-toggle [(ngModel)]="editingAppointmentType.sendReminders" color="primary">
                    Send patients a reminder
                </mat-slide-toggle>
            </div>

            <!-- Per-type length. null = the schedule's duration. The booking form derives the end
                 time from this when the type is chosen; the end time stays editable per booking.
                 Integer values here, unlike the schedule select above — the column is an INTEGER. -->
            <mat-form-field appearance="outline" class="full-width m-t-10">
                <mat-label>Duration</mat-label>
                <mat-select [(ngModel)]="editingAppointmentType.durationMinutes">
                    <mat-option [value]="null">Use schedule default ({{ timeSettings.timeSlotDuration }}
                        minutes)</mat-option>
                    <mat-option *ngFor="let minutes of durationOptions" [value]="minutes">{{ minutes }}
                        minutes</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width m-t-10" *ngIf="locations.length">
                <mat-label>Locations</mat-label>
                <mat-select multiple [(ngModel)]="editingAppointmentType.locationIds">
                    <mat-option *ngFor="let location of locations" [value]="location.id">{{location.name}}</mat-option>
                </mat-select>
                <mat-hint>Leave empty to offer this type at every location</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width m-t-15" *ngIf="calendarSplitByPhysician">
                <mat-label>Default treating physician</mat-label>
                <mat-select [(ngModel)]="editingAppointmentType.defaultPhysicianId">
                    <mat-option [value]="null">None</mat-option>
                    <mat-option *ngFor="let user of groupUsers" [value]="user.userId">{{user.title}} {{user.name}}
                        {{user.surname}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width m-t-10" *ngIf="!stateMode"
                tutorialHighlightTarget="FIELD_APPOINTMENT_CUSTOMIZED">
                <mat-label>
                    {{
                    editingAppointmentType.isProcedure ?
                    'Theatre Email Message' :
                    'Appointment Reminder Message'
                    }}
                </mat-label>
                <textarea matInput [(ngModel)]="editingAppointmentType.reminderMessage" rows="4"></textarea>
            </mat-form-field>

            <ng-container *ngIf="editingAppointmentType.isProcedure">

                <!-- <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Starve Time</mat-label>
                    <input matInput [(ngModel)]="editingAppointmentType.starveTime" [ngxTimepicker]="starveTimePicker"
                        [format]="24">
                    <ngx-material-timepicker #starveTimePicker [theme]="darkTheme" [appendToInput]="true"
                        [preventOverlayClick]="true"></ngx-material-timepicker>
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Hospital Arrive Time</mat-label>
                    <input matInput [(ngModel)]="editingAppointmentType.arriveTime" [ngxTimepicker]="arriveTimePicker"
                        [format]="24">
                    <ngx-material-timepicker #arriveTimePicker [theme]="darkTheme" [appendToInput]="true"
                        [preventOverlayClick]="true"></ngx-material-timepicker>
                </mat-form-field> -->

                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Arrival Location</mat-label>
                    <input matInput [(ngModel)]="editingAppointmentType.arriveLocation">
                </mat-form-field>

            </ng-container>

            <div tutorialHighlightTarget="FIELD_APPOINTMENT_COLORS" class="color-fields-container">
                <div class="color-fields p-b-10">
                    <p>Appointment Background Color:</p>
                    <ngx-colors matTooltip="Set background color for this appointment type" ngx-colors-trigger
                        [(ngModel)]="editingAppointmentType.backgroundColor" [hideTextInput]="true"
                        class="color-picker"></ngx-colors>
                </div>

                <div class="color-fields">
                    <p>Appointment Text Color:</p>
                    <ngx-colors matTooltip="Set text color for this appointment type" ngx-colors-trigger
                        [(ngModel)]="editingAppointmentType.textColor" [hideTextInput]="true"
                        class="color-picker"></ngx-colors>
                </div>

            </div>

            <!-- Survey Template Linking Section -->
            <div class="survey-template-linking-section" *ngIf="!stateMode">
                <h4>Linked Survey Templates</h4>
                <p class="hint">Select which survey templates should be used for this appointment type</p>
                
                <mat-form-field class="full-width" appearance="outline">
                    <mat-label>Linked Survey Templates</mat-label>
                    <mat-chip-grid #surveyTemplateChipGrid>
                        <mat-chip-row *ngFor="let linkedTemplate of getLinkedSurveyTemplates()">
                            {{ linkedTemplate.surveyTitle || linkedTemplate.name }}
                            <button matChipRemove (click)="unlinkSurveyTemplate(linkedTemplate.id)">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                    </mat-chip-grid>
                    <input [matChipInputFor]="surveyTemplateChipGrid" disabled />
                    <mat-hint>Double click a survey template to view its details</mat-hint>
                </mat-form-field>

                <div class="link-survey-template-section">
                    <h5>Link Survey Template</h5>
                    <div class="link-form">
                        <mat-form-field appearance="outline" class="survey-template-select full-width">
                            <mat-label>Select Survey Template</mat-label>
                            <mat-select [(ngModel)]="selectedSurveyTemplateId" 
                                       (selectionChange)="onSurveyTemplateSelectionChange($event.value)">
                                <mat-option *ngFor="let surveyTemplate of getAvailableSurveyTemplates()" 
                                           [value]="surveyTemplate.id">
                                    {{ surveyTemplate.surveyTitle || surveyTemplate.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <mat-dialog-actions align="end">
        <div mat-dialog-actions class="dialog-actions">
            <button mat-raised-button color="primary" [mat-dialog-close]="editingAppointmentType">Save</button>
        </div>
    </mat-dialog-actions>

</ng-template>

<ng-template #appointmentReminderDialog>
    <h1 mat-dialog-title>Appointment Reminder Message</h1>
    <div mat-dialog-content>
        <div class="p-t-20">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Reminder Message</mat-label>
                <textarea matInput [(ngModel)]="group.appointmentReminder" rows="4"></textarea>
            </mat-form-field>

        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" [mat-dialog-close]="group.appointmentReminder">Save</button>
    </div>

</ng-template>